"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var RedirectError =
/*#__PURE__*/
function (_Error) {
  (0, _inherits2.default)(RedirectError, _Error);

  function RedirectError(message) {
    var _this;

    (0, _classCallCheck2.default)(this, RedirectError);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RedirectError).call(this, message || 'Rejecting because of redirect -- prevent promise until reload'));
    _this.name = 'RedirectError';
    return _this;
  }

  return RedirectError;
}((0, _wrapNativeSuper2.default)(Error));

var _default = RedirectError;
exports.default = _default;
module.exports = exports.default;